import React from "react";
import { useMediaQuery } from "@mui/material";
import MemberProfileForm from "../components/MemberProfileForm/MemberProfileForm";
import MemberProfileFormForMobile from "../components/MemberProfileForm/MemberProfileFormForMobile";

function MemberProfileEdit() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return isMobile ? (
    <MemberProfileFormForMobile isEdit />
  ) : (
    <MemberProfileForm isEdit />
  );
}

export default MemberProfileEdit;
